import useMutation from "../useMutation";

export default function useDebtPayment() {
  return useMutation({
    path: `/api/v1/payment-logs`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/inventory-notes`,
      shouldRevalidate: true,
    },
  });
}
